<template>
  <div class="training">
    <audit-temp :final_audit_status="final_audit_status" :final_audit_remark="final_audit_remark" />
    <div class="main">
      <h2 class="title">本年度“包装与食品机械见习工程师”培训与考试安排如下，请参赛团队根据自身规划<em>自愿选择参加</em>。</h2>
      <div class="desc">
        <h4>一、基本信息</h4>
        <p>1.考试方向：机械类、食品科学与工程类、包装工程类<em>（报名时任选其一）</em></p>
        <p>2.培训与考试形式：线上</p>
        <p>3.收费标准：<em>每人200元</em></p>
        <p>4.缴费方式：以团队为单位，通过银行转账统一缴纳。转账总金额 = 参加考试人数 × 200元。</p>
      </div>
      <div class="desc">
        <h5>方式一：对公转账</h5>
        <p>账户名称：中国包装和食品机械有限公司</p>
        <p>银行账号：20000024572600209962610</p>
        <p>开户银行：北京银行太平桥支行</p>
        <p>联行行号：313100001901</p>
        <p>备注格式：高校名称-姓名A-姓名B-姓名C-……（请列出本队所有缴费学生的姓名，中间用短横线连接）</p>
      </div>
      <div class="desc">
        <h5>方式二：扫码缴费</h5>
        <p>扫描下方二维码，并在备注栏注明：高校名称-姓名A-姓名B-姓名C-……（请列出本队所有缴费学生的姓名，中间用短横线连接）</p>
        <img class="ewm" src="https://qn5839.htx.cc/uploads/20260527/FkX5Fza0PZjcK5q1J_mjeZC6n6N8.png">
      </div>
      <div class="desc">
        <h4>二、场次安排</h4>
        <p>本年度共举办两次培训与考试，时间分别为7月8月</p>
        <p>7月场次：在区域赛报名期间同步开放报名</p>
        <p>8月场次：在总决赛报名期间同步开放报名<span>（本次报名即为8月场次）</span></p>
        <p>采用线上培训+线上考试的方式，培训课程将通过邮件通知，考试时间为8月15日9:00~12:00</p>
        <p>特别提醒：每人<i>仅需参加其中一次即可</i>，请勿重复报名。</p>
      </div>
      <div class="desc">
        <h4>三、团队加分说明<em>（需队伍中≥3人通过考试）</em></h4>
        <p>参加7月场次并通过：<i>区域赛加1分；</i>若晋级总决赛，<i>总决赛再加1分</i>。</p>
        <p>参加8月场次并通过：仅当晋级总决赛时，<i>总决赛加1分（区域赛不加分）</i>。</p>
        <p><span>特别说明：</span>2026年参加的考试，<em>其加分资格仅适用于2026年大赛</em>。</p>
      </div>
    </div>
    <template v-if="reg_team_basic.extra_point_status == 1">
      <template v-if="peixunDisabled">
        <template v-if="reg_team_basic.final_extra_point_status > 1">
          <div class="options">
            <h4>您已经参加了8月场次的“包装与食品机械见习工程师”培训与考试（{{ reg_team_basic.final_extra_point_status == 3 ? '总决赛加一分' : '总决赛无附加分'
            }}）</h4>
          </div>
          <div class="member">
            <h4>参加培训成员名单</h4>
            <ul>
              <li v-for="student of train_list" :key="student.id">
                <div class="item" v-if="student.is_train === 2">
                  <div class="msg">
                    <span>姓名：{{ student.name }}</span>
                    <span>身份证号：{{ student.identity }}</span>
                    <span>学号：{{ student.student_id }}</span>
                    <span>学校：{{ student.school_name }}</span>
                    <span>学院：{{ student.college }}</span>
                  </div>
                  <div class="subject">
                    <h5>考试科目</h5>
                    <div class="it" v-for="subject_type of subject_types" :key="subject_type.id">
                      <label class="choose">
                        <i v-if="student.subject === subject_type.id" class="el-icon-check"></i>
                      </label>
                      <span>{{ subject_type.name }}</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </template>
        <template v-else>
          <div class="options">
            <h4>您未参加8月场次的“包装与食品机械见习工程师”培训与考试</h4>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="options">
          <h4>四、是否参加“包装与食品机械见习工程师”培训与考试（8月）</h4>
          <el-radio-group v-model="reg_team_basic.training_status">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </div>
        <div class="member" v-if="reg_team_basic.training_status === 1">
          <h4>请选择参加培训的成员，至少选择三人</h4>
          <ul>
            <li v-for="student of train_list" :key="student.id">
              <div class="item">
                <div class="choose" @click="onChoose(student.id)">
                  <i v-if="student.is_train === 2" class="el-icon-check"></i>
                </div>
                <div class="msg">
                  <span>姓名：{{ student.name }}</span>
                  <span>身份证号：{{ student.identity }}</span>
                  <span>学号：{{ student.student_id }}</span>
                  <span>学校：{{ student.school_name }}</span>
                  <span>学院：{{ student.college }}</span>
                </div>
                <div class="subject">
                  <h5>请选择考试科目</h5>
                  <div class="it" v-for="subject_type of subject_types" :key="subject_type.id"
                    @click="onChooseSubject(student.id, subject_type.id)">
                    <label class="choose">
                      <i v-if="student.subject === subject_type.id" class="el-icon-check"></i>
                    </label>
                    <span>{{ subject_type.name }}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="options">
        <h4>您已经参加了7月场次的“包装与食品机械见习工程师”培训与考试（{{ reg_team_basic.final_extra_point_status == 3 ? '总决赛加一分' : '总决赛无附加分' }}）
        </h4>
      </div>
      <div class="member">
        <h4>参加培训成员名单</h4>
        <ul>
          <li v-for="student of train_list" :key="student.id">
            <div class="item" v-if="student.is_train === 2">
              <div class="msg">
                <span>姓名：{{ student.name }}</span>
                <span>身份证号：{{ student.identity }}</span>
                <span>学号：{{ student.student_id }}</span>
                <span>学校：{{ student.school_name }}</span>
                <span>学院：{{ student.college }}</span>
              </div>
              <div class="subject">
                <h5>考试科目</h5>
                <div class="it" v-for="subject_type of subject_types" :key="subject_type.id">
                  <label class="choose">
                    <i v-if="student.subject === subject_type.id" class="el-icon-check"></i>
                  </label>
                  <span>{{ subject_type.name }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </template>

    <div class="btn">
      <el-button type="primary" icon="el-icon-back" @click="onPrevPage">返回上一项</el-button>
      <el-button type="success" icon="el-icon-circle-check" @click="onSubmit">保存进行下一项</el-button>
    </div>
  </div>
</template>

<script>
import AuditTemp from '@/components/AuditTemp'
import { fetchStudentList, submitTraining, fetchTrainingList } from '@/service/api'

export default {
  name: 'PageTraining',
  components: {
    AuditTemp
  },
  data () {
    return {
      final_audit_status: 3,
      final_audit_remark: '',
      reg_final_expire: false,
      reg_team_basic: {},
      subject_types: [],
      train_list: []
    }
  },
  computed: {
    peixunDisabled () {
      return this.final_audit_status === 5 || this.reg_final_expire || this.reg_team_basic.training_pay_status === 2 || this.reg_team_basic.extra_point_status > 1
    },
    inputDisabled () {
      return this.final_audit_status === 2 || this.final_audit_status === 4 || this.final_audit_status === 5 || this.reg_final_expire
    }
  },
  methods: {
    onPrevPage () {
      this.$router.push('/works')
    },
    async getStudentList () {
      try {
        const data = await fetchStudentList()
        this.reg_final_expire = data.reg_final_expire
        this.reg_team_basic = data.reg_team_basic
        this.final_audit_status = data.reg_team_basic.final_audit_status
        this.final_audit_remark = data.reg_team_basic.final_audit_remark
      } catch (error) {
        console.log('getStudentList error', error)
      }
    },
    async getTrainingList () {
      const res = await fetchTrainingList()
      this.subject_types = res.subject_type_config
      this.train_list = res.list
    },
    onChoose (id) {
      if (this.peixunDisabled) {
        return
      }
      for (const train of this.train_list) {
        if (id === train.id) {
          train.is_train = train.is_train === 1 ? 2 : 1
        }
      }
    },
    onChooseSubject (trainId, subjectId) {
      if (this.peixunDisabled) {
        return
      }
      for (const train of this.train_list) {
        if (trainId === train.id) {
          train.subject = subjectId
          break
        }
      }
    },
    async onSubmit () {
      if (this.peixunDisabled) {
        this.$router.push('/hotel')
        return
      }

      const trainData = this.train_list.filter(item => item.is_train === 2)
      const noSubject = this.train_list.filter(item => item.is_train === 2 && !item.subject)

      if (this.reg_team_basic.training_status === 1 && trainData.length < 3) {
        this.$alert('请至少选择3人参加“包装与食品机械见习工程师”课程培训与考试', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (noSubject.length > 0) {
        this.$alert('请为参加培训与考试的成员选择科目', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      }

      if (this.reg_team_basic.training_status === 1) {
        this.$confirm('确认已经缴费并提交信息吗？ ', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const loading = this.$loading({
            lock: true,
            text: '提交中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.9)'
          })
          await submitTraining({
            training_status: this.reg_team_basic.training_status,
            trainData
          })
          loading.close()
          this.$router.push('/hotel')
        }).catch(() => {
          console.log('取消')
        })
      } else {
        const loading = this.$loading({
          lock: true,
          text: '提交中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.9)'
        })
        await submitTraining({
          training_status: this.reg_team_basic.training_status,
          trainData
        })
        loading.close()
        this.$router.push('/hotel')
      }
    }
  },
  async mounted () {
    document.body.style.height = 'auto'
    const loading = this.$loading({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.9)'
    })
    await this.getStudentList()
    await this.getTrainingList()
    loading.close()
  },
  unmounted () {
    document.body.style.height = '100%'
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
